<template>
  <v-container fluid class="hir px-0 pt-0">
    <div class="page-content">
      <div v-if="!hirLoading">
        <div v-if="hir">
          <div class="card-single-post mb-3">
            <img :src="hir.Kep + '?h=400'" :alt="hir.Cim" />
            <div class="card-single-post-infos">
              <div class="card-single-post-infos-inner">
                <h1 class="mb-3">{{ hir.Cim }}</h1>
                <p class="hirismerteto" v-if="hir.VezerHirFl">
                  {{ hir.Ismerteto }}
                </p>
                <div class="card-single-post-author">
                  <v-img
                    :src="
                      hir.Szerzo.Kep
                        ? hir.Szerzo.Kep + '?w=32&h=32'
                        : $placeholderImage
                    "
                    height="32px"
                    max-height="32px"
                    width="32px"
                    max-width="32px"
                    class="rounded"
                  >
                  </v-img>
                  <span class="dot-separator white mx-2"></span>
                  <span>{{ hir.Szerzo.Nev }}</span>
                  <span class="dot-separator white mx-2"></span>
                  <span class="white--text">{{
                    hir.MegjelenesDatuma | toShortDate
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <p class="white--text hirismerteto px-3" v-if="!hir.VezerHirFl">
            {{ hir.Ismerteto }}
          </p>
          <div
            class="ck-content px-3"
            v-if="hir"
            v-html="hir.Tartalom"
            v-highlightjs
          ></div>
        </div>
        <div v-else class="fill-height" :style="contentHeight">
          <k-nodata-info>
            <template v-slot:icon>
              <i class="fas fa-exclamation"></i>
            </template>
            <template v-slot:title>
              {{ nyelvesites['sikertelen_cikk_betoltes_text'] }}
            </template>
          </k-nodata-info>
        </div>
      </div>
      <div v-else>
        <v-progress-circular
          indeterminate
          color="primary"
          class="absolute-center"
        ></v-progress-circular>
      </div>
    </div>
    <div class="text-center mb-11">
      <cikk-admin-link :hirId="hir.Id"></cikk-admin-link>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { NotificationFunctions } from '../functions/NotificationFunctions';
import { hirService } from '../services/HirService';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'MegosztottHir',
  data() {
    return {
      hirLoading: false,
      hir: '',
      projekt: null,
    };
  },
  mounted() {},
  created() {},
  methods: {
    async GetHir() {
      this.hirLoading = true;
      try {
        let result = await hirService.GetMegosztottCikk(this.azon);
        this.hir = result.Hir;
        this.projekt = result.Projekt;
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.hirLoading = false;
    },
    goBack() {
      this.$store.dispatch(AppStoreTypes.pageTransition.set, {
        value: {
          name: 'router-view-back',
          mode: '',
        },
      });
      // this.$router.push('/fooldal/');
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/fooldal/');
    },
  },
  computed: {
    ...mapGetters({ user: AppStoreTypes.user.get }),
    isLoggedIn() {
      return this.user != null;
    },
    azon() {
      return this.$route.params.azon;
    },
    contentHeight() {
      let bottomNavHeight = this.$vuetify.application.bottom;
      //prettier-ignore
      return 'height: 100vh; overflow-y: scroll;';
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {
    hirId: {
      handler: function(v) {
        this.GetHir();
      },
      immediate: true,
    },
  },
};
</script>
